// extracted by mini-css-extract-plugin
module.exports = {"messageContainer":"MessageContainer_messageContainer__1_sUB","loader":"MessageContainer_loader__Ulkc8","rotation":"MessageContainer_rotation__wjsLQ"};